import React, { useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Button, ChipsItem, HeaderTitle, Input, Label } from '@atlas/ui';

import GlobalErrors from 'common/Form/GlobalErrors';
import useRealityCheckSettings from 'hooks/useRealityCheckSettings';
import { useSelfRegulationContext } from 'src/components/SelfRegulationProvider';

const UNIT_LABELS = {
  HOUR: 'reality_check_custom_hours',
  MINUTE: 'reality_check_custom_min',
};

const getOptionLabel = option => {
  if (option === 'CUSTOM') return <Label message="reality_check_custom_time" />;
  const [unit, value] = option.split('_');

  return (
    <span>
      {value} <Label message={UNIT_LABELS[unit] || unit.toLowerCase()} />
    </span>
  );
};

const RealityCheckInput = ({ label, onBlur, onChange, value }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <Input
      active={isActive}
      label={label}
      onBlur={() => {
        setIsActive(false);
        onBlur?.();
      }}
      onChange={onChange}
      onFocus={() => {
        setIsActive(true);
      }}
      value={value}
    />
  );
};

const RealityCheckV2 = () => {
  const { markSelfRegulationAsSet } = useSelfRegulationContext();

  const {
    customHours,
    customMinutes,
    errors,
    isButtonDisabled,
    loading,
    onHoursChange,
    onMinutesBlur,
    onMinutesChange,
    onSaveHandler,
    selectedOption,
    setErrors,
    setSelectedOption,
    timeOptions,
  } = useRealityCheckSettings({
    onSaveSuccess: markSelfRegulationAsSet,
  });

  const isCustomOption = selectedOption === 'CUSTOM';

  return (
    <div className="reality-check-container">
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium" title="about_reality_check" />
      </div>
      <Label
        className="title-small-normal-text desc-reality-check"
        message="reality_check_message"
      />
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-medium" title="reality_check_select_period" />
      </div>

      <div className="chips-list chips-list-wrap">
        {timeOptions.map(option => {
          const onClickHandler = () => {
            setSelectedOption(option);
            setErrors([]);
          };

          return (
            <ChipsItem
              active={selectedOption === option}
              className="deposit-amounts-chip"
              key={option}
              label={getOptionLabel(option)}
              onClick={onClickHandler}
            />
          );
        })}
      </div>

      {isCustomOption && (
        <div className="reality-check-custom">
          <Label className="content__label" message="reality_check_custom_set" />
          <div
            className={cx('inputs', {
              error: errors.length > 0,
            })}
          >
            <RealityCheckInput label="Hours" onChange={onHoursChange} value={customHours} />
            <RealityCheckInput
              label="Minutes"
              onBlur={onMinutesBlur}
              onChange={onMinutesChange}
              value={customMinutes}
            />
          </div>
          <GlobalErrors globalErrors={errors} />
        </div>
      )}

      <div className="save-button-container">
        <Button
          className="save-button"
          disabled={isButtonDisabled}
          label="save"
          loading={loading}
          onClick={onSaveHandler}
          size="big"
          type="primary"
        />
      </div>
    </div>
  );
};

RealityCheckInput.propTypes = {
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default RealityCheckV2;
